import { render, staticRenderFns } from "./TokenInformation.vue?vue&type=template&id=3061cb40"
import script from "./TokenInformation.vue?vue&type=script&lang=js"
export * from "./TokenInformation.vue?vue&type=script&lang=js"
import style0 from "./TokenInformation.vue?vue&type=style&index=0&id=3061cb40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports